import React from 'react';
import PropTypes from 'prop-types';
import Waypoint from 'react-waypoint';
import RatioImg from '../ratio-img';

export default class LazyImg extends React.PureComponent {

  static propTypes = {
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    styles: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    bottomOffset: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }

  static defaultProps = {
    bottomOffset: -500,
  }

  state = {
    visible: false,
  }

  loadImg = (e) => {
    if (e.waypointTop === e.waypointBottom) return;

    this.setState({
      visible: true,
    });
  }

  render() {
    const { visible } = this.state;
    const {
      src,
      srcSet,
      picture,
      width,
      height,
      styles,
      bottomOffset,
      ...rest
    } = this.props;

    return (
      <Waypoint
        onEnter={this.loadImg}
        bottomOffset={bottomOffset}
      >
        <RatioImg
          width={width}
          height={height}
          styles={styles}
          src={visible ? src : undefined}
          srcSet={visible ? srcSet : undefined}
          picture={visible ? picture : undefined}
          {...rest}
        />
      </Waypoint>
    );
  }
}
